import React, { createContext, useEffect, useRef, useState } from "react";

export const CardContext = createContext(null);

export const CardProvider = ({ children }) => {
	const [flipped, setFlipped] = useState(false);
	const [randomNum, setRandomNum] = useState("");
	const [cardData, setCardData] = useState({});

	const firstUpdate = useRef(true);
	useEffect(() => {
		if (firstUpdate.current) {
			firstUpdate.current = false;
			return;
		}
		fetch(`${process.env.REACT_APP_API_URL}/getCard/${randomNum}`)
			.then((res) => res.json())
			.then((data) => {
				setCardData(() => Object.values(data)[2]);
			});
	}, [randomNum]);

	return (
		<CardContext.Provider
			value={{
				cardData,
				setCardData,
				flipped,
				setFlipped,
				randomNum,
				setRandomNum,
			}}
		>
			{children}
		</CardContext.Provider>
	);
};
